module.exports = __webpack_public_path__ + "static/oceanechologo-afe61b02f717822425957d716e1ba887.png";